/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AgencyCreationRequest } from './';
import {
    AgencyCreationRequestFromJSON,
    AgencyCreationRequestFromJSONTyped,
    AgencyCreationRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface CheckAgencyForExistingAccountRequest
 */
export interface CheckAgencyForExistingAccountRequest {
    /**
     * 
     * @type {AgencyCreationRequest}
     * @memberof CheckAgencyForExistingAccountRequest
     */
    agency: AgencyCreationRequest;
}

/**
 * Check if a given object implements the CheckAgencyForExistingAccountRequest interface.
 */
export function instanceOfCheckAgencyForExistingAccountRequest(value: object): value is CheckAgencyForExistingAccountRequest {
    if (!('agency' in value) || value['agency'] === undefined) return false;
    return true;
}

export function CheckAgencyForExistingAccountRequestFromJSON(json: any): CheckAgencyForExistingAccountRequest {
    return CheckAgencyForExistingAccountRequestFromJSONTyped(json, false);
}

export function CheckAgencyForExistingAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckAgencyForExistingAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'agency': AgencyCreationRequestFromJSON(json['agency']),
    };
}

export function CheckAgencyForExistingAccountRequestToJSON(value?: CheckAgencyForExistingAccountRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'agency': AgencyCreationRequestToJSON(value['agency']),
    };
}

